import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';
import { FORM_VALIDATION_ERRORS } from 'src/consts';

const initialValues = {
  email: '',
  password: '',
  zipCode: '',
  firstName: '',
  lastName: '',
  phone: '',
  employeeBadge: '',
};

const schema = () =>
  Yup.object().shape({
    email: capsuleValidation.email(),
    password: capsuleValidation.password(),
    zipCode: capsuleValidation.zip().required(FORM_VALIDATION_ERRORS.zip),
    firstName: Yup.string().required(FORM_VALIDATION_ERRORS.firstName),
    lastName: Yup.string().required(FORM_VALIDATION_ERRORS.lastName),
    phone: capsuleValidation.phone().required(FORM_VALIDATION_ERRORS.mobilePhone),
  });

export const validation = {
  initialValues,
  schema,
};
